import {createSelector} from "reselect";
import {RateModel, RateModelEntity, RateModelType} from "../../../model/rate-model";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";

export type RateModelSelectorProps = {
  regionId?: string
  type?: RateModelType;
};

const getRegionIdParam = createParamSelector<RateModelSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getTypeParam = createParamSelector<RateModelSelectorProps | undefined, RateModelType | undefined>(params => params?.type);

export const rateModelsSelector = () => createSelector(
  [getUseQueryResultData<RateModel[]>, getRegionIdParam, getTypeParam],
  (data, regionId, type) => {
    return selectRateModelsAndTransform(
      data ?? [], {
        regionId: regionId,
        type: type
      }
    );
  }
);

export const rateModelSelector = () => createSelector(
  [getUseQueryResultData<RateModel>],
  (data) => {
    return data ? transformRateModel(data) : undefined;
  }
);

export const selectRateModels = (values?: RateModel[], selector?: RateModelSelectorProps): RateModel[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (selector.regionId !== v.regionId) {
        filterIn = false
      }
    }

    if (selector?.type) {
      if (selector.type.code !== v.type) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformRateModel = (value: RateModel): RateModelEntity => {
  return RateModelEntity.from(value)
}

export const selectRateModelsAndTransform = (values?: RateModel[], selector?: RateModelSelectorProps): RateModelEntity[] => {
  const selected = selectRateModels(values, selector);
  return selected.map(transformRateModel);
};
